// extracted by mini-css-extract-plugin
module.exports = {"body":"Bullets_body__1ixZh","bullet-animation":"Bullets_bullet-animation__JDrai","laser":"Bullets_laser__1uLV8","minigun":"Bullets_minigun__1-gKL","plasma":"Bullets_plasma__1HLwb"};